import Drive from "./Drive";

export default function View() {
    return <Drive readonly={true} />;
}
